import React from 'react';

import { ColourRichContent } from './HTMLmockup/ColourRichContent';
import { ClearRichContent } from './HTMLmockup/ClearRichContent';
import './ContactLensRichContent.scss';

export const ContactLensRichContent = props => {
  const {
    isShowRichContent = false,
    contentHtml = null,
    isClearContactLens = false,
    isColourContactLens = false,
  } = props;

  // const isOpen = isShowRichContent && contentHtml && contentHtml !== null;
  const isOpen = true;

  const getHtmlString = () => {
    if (isClearContactLens) {
      // In the future: return raw HTML string from backend
      return null;
    }
    if (isColourContactLens) {
      return null;
    }
    return null;
  };

  const renderMockComponent = () => {
    if (isClearContactLens) {
      return <ClearRichContent />;
    }
    if (isColourContactLens) {
      return <ColourRichContent />;
    }
    return null;
  };

  return isOpen ? (
    <div className="contact-lens-rich-content__wrapper">
      {getHtmlString() ? (
        <div dangerouslySetInnerHTML={{ __html: getHtmlString() }} />
      ) : (
        renderMockComponent()
      )}
    </div>
  ) : null;
};
